export default __webpack_public_path__ + "app/images/ic-48-image.svg";